import { Redline } from 'redline-client-sdk';

import RLPayloadCreator from '../debts/rl-debts-payload.creator';

import type { AtendeAgreementOutcomeReceived } from './types';

export const atendeEvents = (rl: Redline) => ({

	/**
   * @description Rastreia o evento de sucesso no retorno da /fechar somente quando esse acordo foi fechado via Atende , sinalizando que o acordo foi fechado com êxito.
   *
	 * @param {string} props.atendeUser - Identificador do usuário no sistema Atende.
   * @param {paymentOption} props.paymentOption - Opção de pagamento selecionada.
   * @param {Debt} props.debt - Objeto da dívida atual.
   * @param {any} props.agreement - Objeto do acordo fechado.
   * @param {any} props.selectedPaymentDate - Data de vencimento selecionada pelo usuário.
   *
   * @example
   * track.atende.agreementOutcomeReceived({
	 * 		atendeUser: atendeuser@empresa.com.br,
   *  	paymentOption: paymentOption,
   *  	debt: debt,
   *  	agreement: agreement,
   * });
   */
  agreementOutcomeReceived(props: AtendeAgreementOutcomeReceived) {
    rl.track('atende.AgreementOutcomeReceived.v1', {
      ...RLPayloadCreator.EventsDebtsContext(props),
			atendeUser: props.atendeUser
    });
  },
});